import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const sendContactMessage = (payload) => axios.post(`${API}/contact`, payload);

export const bookConsultation = (payload) => axios.post(`${API}/consultations`, payload);
